"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const createIconComponent_1 = require("../createIconComponent");
const pathProps = {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
};
exports.default = createIconComponent_1.default("TShirt", React.createElement(React.Fragment, null,
    React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", "stroke-miterlimit": "10", d: "M16.3 2.8l6.8 4.8-2.4 2.8-2.8-1.2v12.1H5.8V8.9l-2.6 1.3L.9 7.5l6.9-4.8c4.7 9.3 8.5.1 8.5.1z" }),
    React.createElement("path", { fill: "none", d: "M34.2 32.7h40.3v40H34.2zM-30.9-8.6h40v44.9h-40z" })));
//# sourceMappingURL=TShirt.js.map